import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import { useTokenStore } from '@/store/token'
import { useUserStore } from '@/store/user'
import { useReuseTabStore } from '@/store/reuse-tab'
import { useMixAuthStore } from '@/store/mix-auth'
import pinia from '../../../gx-hall/src/store'
import {
  HALL_ACTIVE_RULE,
  EXPERT_APP_NAME,
  EXPERT_ACTIVE_RULE,
  EXPERT_PRO_PUBLIC_PATH,
  EXPERT_DEV_PUBLIC_PATH,
  EXPERT_DEV_PORT,
  MANAGER_APP_NAME,
  MANAGER_PRO_PUBLIC_PATH,
  MANAGER_DEV_PUBLIC_PATH,
  MANAGER_ACTIVE_RULE,
  MANAGER_DEV_PORT,
  BIGSCREEN_APP_NAME,
  BIGSCREEN_PRO_PUBLIC_PATH,
  BIGSCREEN_DEV_PUBLIC_PATH,
  BIGSCREEN_ACTIVE_RULE,
  BIGSCREEN_DEV_PORT,
  SYSTEM_APP_NAME,
  SYSTEM_PRO_PUBLIC_PATH,
  SYSTEM_DEV_PUBLIC_PATH,
  SYSTEM_ACTIVE_RULE,
  SYSTEM_DEV_PORT,
  REPORT_APP_NAME,
  REPORT_PRO_PUBLIC_PATH,
  REPORT_DEV_PUBLIC_PATH,
  REPORT_ACTIVE_RULE,
  REPORT_DEV_PORT,
} from '../../../../micro/micro-config'
import WorkbenchPage from '@/views/workbench/Index.vue'

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace
//push
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return originalPush.call(this, location).catch((err) => err)
}
//replace
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return originalReplace.call(this, location).catch((err) => err)
}

const routes: Array<RouteConfig> = [
  {
    path: '/',
    redirect: '/hall',
  },
  {
    path: '/workbench',
    component: () => import('@/layout/main/WorkbenchLayout.vue'),
    children: [
      {
        path: '',
        component: WorkbenchPage,
        meta: {
          title: '首页',
          backgroundColor: 'transparent',
        },
      },
    ],
  },
  {
    path: '/mixauthlogin',
    component: () => import('@/views/MixAuthLogin.vue'),
    meta: {
      title: '融合授权单点登录',
      invisibleInTab: true,
    },
  },
  {
    path: '/account-manage',
    component: () => import('@/layout/main/WorkbenchLayout.vue'),
    children: [
      {
        path: 'user',
        name: '/account-manage/user',
        component: () => import('@/views/account-manage/UserList.vue'),
        meta: {
          title: '用户信息',
        },
      },
      {
        path: 'enterprise',
        name: '/account-manage/enterprise',
        component: () => import('@/views/account-manage/EnterpriseList.vue'),
        meta: {
          title: '企业信息',
        },
      },
    ],
  },
  {
    path: '/large-screen',
    component: () => import('@/views/MicroApp.vue'),
    meta: {
      appName: BIGSCREEN_APP_NAME,
      activeRule: BIGSCREEN_ACTIVE_RULE,
      proPublicPath: BIGSCREEN_PRO_PUBLIC_PATH,
      devPublicPath: BIGSCREEN_DEV_PUBLIC_PATH,
      devPort: BIGSCREEN_DEV_PORT,
    },
  },
  {
    path: '/register',
    component: () => import('@/views/MicroApp.vue'),
    meta: {
      invisibleInTab: true,
      appName: MANAGER_APP_NAME,
      activeRule: MANAGER_ACTIVE_RULE,
      proPublicPath: MANAGER_PRO_PUBLIC_PATH,
      devPublicPath: MANAGER_DEV_PUBLIC_PATH,
      devPort: MANAGER_DEV_PORT,
    },
  },
  {
    path: '/pdf/*',
    component: () => import('@/views/MicroApp.vue'),
    meta: {
      appName: EXPERT_APP_NAME,
      activeRule: EXPERT_ACTIVE_RULE,
      proPublicPath: EXPERT_PRO_PUBLIC_PATH,
      devPublicPath: EXPERT_DEV_PUBLIC_PATH,
      devPort: EXPERT_DEV_PORT,
    },
  },
  {
    path: '/g-project',
    component: () => import('@/views/MicroApp.vue'),
    meta: {
      invisibleInTab: true,
      appName: MANAGER_APP_NAME,
      activeRule: MANAGER_ACTIVE_RULE,
      proPublicPath: MANAGER_PRO_PUBLIC_PATH,
      devPublicPath: MANAGER_DEV_PUBLIC_PATH,
      devPort: MANAGER_DEV_PORT,
    },
  },
  {
    path: '/bimface/bimface-loader',
    component: () => import('@/views/MicroApp.vue'),
    meta: {
      appName: MANAGER_APP_NAME,
      activeRule: MANAGER_ACTIVE_RULE,
      proPublicPath: MANAGER_PRO_PUBLIC_PATH,
      devPublicPath: MANAGER_DEV_PUBLIC_PATH,
      devPort: MANAGER_DEV_PORT,
    },
  },
  {
    path: '/engineering-management/fire-design/edit/gg/:id',
    component: () => import('@/views/MicroApp.vue'),
    meta: {
      invisibleInTab: true,
      appName: MANAGER_APP_NAME,
      activeRule: MANAGER_ACTIVE_RULE,
      proPublicPath: MANAGER_PRO_PUBLIC_PATH,
      devPublicPath: MANAGER_DEV_PUBLIC_PATH,
      devPort: MANAGER_DEV_PORT,
    },
  },
  {
    path: '/engineering-management/fire-acceptance/edit/gg/:id',
    component: () => import('@/views/MicroApp.vue'),
    meta: {
      invisibleInTab: true,
      appName: MANAGER_APP_NAME,
      activeRule: MANAGER_ACTIVE_RULE,
      proPublicPath: MANAGER_PRO_PUBLIC_PATH,
      devPublicPath: MANAGER_DEV_PUBLIC_PATH,
      devPort: MANAGER_DEV_PORT,
    },
  },
  {
    path: '/engineering-management/fire-completed/edit/gg/:id',
    component: () => import('@/views/MicroApp.vue'),
    meta: {
      invisibleInTab: true,
      appName: MANAGER_APP_NAME,
      activeRule: MANAGER_ACTIVE_RULE,
      proPublicPath: MANAGER_PRO_PUBLIC_PATH,
      devPublicPath: MANAGER_DEV_PUBLIC_PATH,
      devPort: MANAGER_DEV_PORT,
    },
  },
  {
    path: '/statistics-report',
    component: () => import('@/views/MicroApp.vue'),
    meta: {
      appName: BIGSCREEN_APP_NAME,
      activeRule: BIGSCREEN_ACTIVE_RULE,
      proPublicPath: BIGSCREEN_PRO_PUBLIC_PATH,
      devPublicPath: BIGSCREEN_DEV_PUBLIC_PATH,
      devPort: BIGSCREEN_DEV_PORT,
    },
  },
  {
    path: '/department-datav',
    component: () => import('@/views/MicroApp.vue'),
    meta: {
      appName: BIGSCREEN_APP_NAME,
      activeRule: BIGSCREEN_ACTIVE_RULE,
      proPublicPath: BIGSCREEN_PRO_PUBLIC_PATH,
      devPublicPath: BIGSCREEN_DEV_PUBLIC_PATH,
      devPort: BIGSCREEN_DEV_PORT,
    },
  },
  {
    path: '/article-lib/article-manager',
    component: () => import('@/views/MicroApp.vue'),
    meta: {
      appName: SYSTEM_APP_NAME,
      activeRule: SYSTEM_ACTIVE_RULE,
      proPublicPath: SYSTEM_PRO_PUBLIC_PATH,
      devPublicPath: SYSTEM_DEV_PUBLIC_PATH,
      devPort: SYSTEM_DEV_PORT,
    },
  },
  {
    path: '/article-lib/latestSpecifications',
    component: () => import('@/views/MicroApp.vue'),
    meta: {
      appName: SYSTEM_APP_NAME,
      activeRule: SYSTEM_ACTIVE_RULE,
      proPublicPath: SYSTEM_PRO_PUBLIC_PATH,
      devPublicPath: SYSTEM_DEV_PUBLIC_PATH,
      devPort: SYSTEM_DEV_PORT,
    },
  },
  {
    path: '/article-lib/article-search',
    component: () => import('@/views/MicroApp.vue'),
    meta: {
      appName: SYSTEM_APP_NAME,
      activeRule: SYSTEM_ACTIVE_RULE,
      proPublicPath: SYSTEM_PRO_PUBLIC_PATH,
      devPublicPath: SYSTEM_DEV_PUBLIC_PATH,
      devPort: SYSTEM_DEV_PORT,
    },
  },
  {
    path: '/article-lib/articleDetail',
    component: () => import('@/views/MicroApp.vue'),
    meta: {
      appName: SYSTEM_APP_NAME,
      activeRule: SYSTEM_ACTIVE_RULE,
      proPublicPath: SYSTEM_PRO_PUBLIC_PATH,
      devPublicPath: SYSTEM_DEV_PUBLIC_PATH,
      devPort: SYSTEM_DEV_PORT,
    },
  },
  {
    path: '/article-lib/inspection-manual-detail',
    component: () => import('@/views/MicroApp.vue'),
    meta: {
      appName: SYSTEM_APP_NAME,
      activeRule: SYSTEM_ACTIVE_RULE,
      proPublicPath: SYSTEM_PRO_PUBLIC_PATH,
      devPublicPath: SYSTEM_DEV_PUBLIC_PATH,
      devPort: SYSTEM_DEV_PORT,
    },
  },
  {
    path: '/article-lib/common-problem-detail',
    component: () => import('@/views/MicroApp.vue'),
    meta: {
      appName: SYSTEM_APP_NAME,
      activeRule: SYSTEM_ACTIVE_RULE,
      proPublicPath: SYSTEM_PRO_PUBLIC_PATH,
      devPublicPath: SYSTEM_DEV_PUBLIC_PATH,
      devPort: SYSTEM_DEV_PORT,
    },
  },
  {
    path: '/tymhsso',
    component: () => import('@/views/UnifiedPortalSSO.vue'),
    meta: {
      title: '统一门户登录',
      invisibleInTab: true,
    },
  },
  {
    path: '/bigscreen/designer',
    component: () => import('@/views/MicroApp.vue'),
    meta: {
      appName: REPORT_APP_NAME,
      activeRule: REPORT_ACTIVE_RULE,
      proPublicPath: REPORT_PRO_PUBLIC_PATH,
      devPublicPath: REPORT_DEV_PUBLIC_PATH,
      devPort: REPORT_DEV_PORT,
    },
  },
  {
    path: '/bigscreen/viewer',
    component: () => import('@/views/MicroApp.vue'),
    meta: {
      appName: REPORT_APP_NAME,
      activeRule: REPORT_ACTIVE_RULE,
      proPublicPath: REPORT_PRO_PUBLIC_PATH,
      devPublicPath: REPORT_DEV_PUBLIC_PATH,
      devPort: REPORT_DEV_PORT,
    },
  },
  {
    path: '/statisticsReport',
    component: () => import('@/views/MicroApp.vue'),
    meta: {
      appName: REPORT_APP_NAME,
      activeRule: REPORT_ACTIVE_RULE,
      proPublicPath: REPORT_PRO_PUBLIC_PATH,
      devPublicPath: REPORT_DEV_PUBLIC_PATH,
      devPort: REPORT_DEV_PORT,
    },
  },
  {
    path: '/examination-management/start-exam',
    component: () => import('@/views/MicroApp.vue'),
    meta: {
      appName: MANAGER_APP_NAME,
      activeRule: MANAGER_ACTIVE_RULE,
      proPublicPath: MANAGER_PRO_PUBLIC_PATH,
      devPublicPath: MANAGER_DEV_PUBLIC_PATH,
      devPort: MANAGER_DEV_PORT,
    },
  },
  {
    path: '/original-record/form',
    component: () => import('@/views/MicroApp.vue'),
    meta: {
      appName: MANAGER_APP_NAME,
      activeRule: MANAGER_ACTIVE_RULE,
      proPublicPath: MANAGER_PRO_PUBLIC_PATH,
      devPublicPath: MANAGER_DEV_PUBLIC_PATH,
      devPort: MANAGER_DEV_PORT,
    },
  },
  {
    path: '/original-record/detail',
    component: () => import('@/views/MicroApp.vue'),
    meta: {
      appName: MANAGER_APP_NAME,
      activeRule: MANAGER_ACTIVE_RULE,
      proPublicPath: MANAGER_PRO_PUBLIC_PATH,
      devPublicPath: MANAGER_DEV_PUBLIC_PATH,
      devPort: MANAGER_DEV_PORT,
    },
  },
  {
    path: '/test-report/report-form',
    component: () => import('@/views/MicroApp.vue'),
    meta: {
      appName: MANAGER_APP_NAME,
      activeRule: MANAGER_ACTIVE_RULE,
      proPublicPath: MANAGER_PRO_PUBLIC_PATH,
      devPublicPath: MANAGER_DEV_PUBLIC_PATH,
      devPort: MANAGER_DEV_PORT,
    },
  },
  {
    path: '/test-report/report-detail',
    component: () => import('@/views/MicroApp.vue'),
    meta: {
      appName: MANAGER_APP_NAME,
      activeRule: MANAGER_ACTIVE_RULE,
      proPublicPath: MANAGER_PRO_PUBLIC_PATH,
      devPublicPath: MANAGER_DEV_PUBLIC_PATH,
      devPort: MANAGER_DEV_PORT,
    },
  },
  {
    path: '/test-report/third-level-detail',
    component: () => import('@/views/MicroApp.vue'),
    meta: {
      appName: MANAGER_APP_NAME,
      activeRule: MANAGER_ACTIVE_RULE,
      proPublicPath: MANAGER_PRO_PUBLIC_PATH,
      devPublicPath: MANAGER_DEV_PUBLIC_PATH,
      devPort: MANAGER_DEV_PORT,
    },
  },
  {
    path: '/UnifiedSupport',
    component: () => import('@/views/UnifiedSupport.vue'),
    meta: {
      title: '统一支撑',
      invisibleInTab: true,
    },
  },
]
const router = new VueRouter({
  mode: 'history',
  routes,
})
router.beforeEach((to, from, next) => {
  const tokenStore = useTokenStore(pinia)
  const token = tokenStore.getToken()
  const userStore = useUserStore(pinia)
  const mixAuthStore = useMixAuthStore(pinia)
  if (to.meta?.title) {
    document.title = to.meta.title
  }
  if (!token) {
    if (to.hash.includes('g-project')) {
      gProjectHash(to)
    } else if (to.path.startsWith(HALL_ACTIVE_RULE) || to.meta?.invisibleInTab) {
      next()
    } else if (to.path.startsWith('/workbench') && !!mixAuthStore.getToken()) {
      next()
    } else if (to.path.startsWith('/account-manage') && !!mixAuthStore.getToken()) {
      next()
    } else {
      next({
        path: '/hall',
        query: { redirect: to.path },
      })
    }
  } else {
    const reuseTabStore = useReuseTabStore(pinia)
    userStore.logged().then(() => {
      if (to.hash.includes('g-project')) {
        gProjectHash(to)
      } else {
        next()
      }
      if (to.path !== '/fire/home' && !to.meta?.invisibleInTab) {
        reuseTabStore.add({
          name: '首页',
          path: '/fire/home',
          title: '首页',
          closable: false,
        })
      }
    })
  }
})
function gProjectHash(to) {
  const query = to.hash.split('?')[1]
  window.location.href = `/g-project${query ? `?${query}` : ''}`
}

export default router
